import { Component, OnInit } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { Router } from '@angular/router';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {

  constructor(
    private identityService: IdentityService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.identityService.isLoggedIn()) {
      this.router.navigate([AppUrls.home()]);
    }
  }

  signIn() {
    this.identityService.redirectToThirdPartyLogin();
  }
}
